import React from "react";
import PropTypes from "prop-types";
import { TestBox } from "../index";
import I18N from "../../I18N";
import "./versionsDisplay.scss";

const VersionsDisplay = ({ versions, handleReTest }) => {
  const { endPointVersions, masterVersions, isLoading } = versions;
  return (
    <TestBox
      testName={I18N.t("VERSIONS")}
      handleReTest={handleReTest}
      isLoading={isLoading}
    >
      <ol className="versions-display">
        {endPointVersions &&
          Object.keys(endPointVersions).map(key => (
            <li key={key} className="versions-display__item">
              <span>{key}</span>
              <span> {endPointVersions[key]}</span>
              <span> {masterVersions[key]}</span>
            </li>
          ))}
      </ol>
    </TestBox>
  );
};

VersionsDisplay.propTypes = {
  versions: PropTypes.object.isRequired,
  handleReTest: PropTypes.func.isRequired
};
VersionsDisplay.defaultProps = {};

export default VersionsDisplay;
